import { useEffect, useState } from 'react';

import { trackAnalyticsData, AnalyticsEvent } from 'utils/analytics';

import * as T from './DailyQuestion.types';
import * as C from './DailyQuestion.const';

export const useSwitchStage = () => {
  const [stage, setStage] = useState<C.STAGES>(C.STAGES.INITIAL);
  const [isDisappearing, setDisappearing] = useState<boolean>(false);

  const switchStage = (newStage: C.STAGES) => {
    if (stage !== newStage) {
      setDisappearing(true);

      setTimeout(() => {
        setStage(newStage);
        setDisappearing(false);
      }, C.SWITCH_ANIMATION_DURATION_MS);
    }
  };

  return { stage, isDisappearing, switchStage };
};

export const useContentAnalytics: T.TUseContentAnalytics = (ref, deps) => {
  useEffect(() => {
    const linkClickHandler = async () => {
      try {
        await trackAnalyticsData(
          AnalyticsEvent.DAILY_QUESTION_CONTENT_LINK_CLICK
        );
      } catch (err) {
        console.error(err);
      }
    };

    const aElems = ref.current?.querySelectorAll('a');

    aElems?.forEach((elem) => {
      elem.addEventListener('click', linkClickHandler);
    });

    return () => {
      aElems?.forEach((elem) => {
        elem.removeEventListener('click', linkClickHandler);
      });
    };
  }, deps);
};
